import { css } from '@styles/theme'

export const disciplineStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',

		'&.AccordionTrigger': {
			color: 'red',
		},

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),

	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		gap: '16px',

		'@sm': {
			marginTop: '40px',
		},
	}),

	containerAccordion: css({
		marginTop: '24px',
	}),

	containerButtonNextPage: css({
		display: 'flex',
		justifyContent: 'center',
		gap: '29px',
		marginBottom: '80px',

		button: {
			maxWidth: '178px',
		},
	}),
}
